export const languages = [
  { code: "it", name: "イタリア語" },
  { code: "de", name: "ドイツ語" },
  { code: "fr", name: "フランス語" },
  { code: "ru", name: "ロシア語" },
  { code: "en", name: "英語" },
  { code: "ja", name: "日本語" },
];

export function codeToName(code) {
  const item = languages.find((l) => l.code === code);
  return item && item.name;
}
